import { Injectable, EventEmitter, Output } from '@angular/core';
import { Http, RequestOptions, Response, URLSearchParams, Headers } from '@angular/http';
import { CookieService } from 'ngx-cookie';
import { Subject, Observable } from 'rxjs/Rx';
import { Angulartics2 } from 'angulartics2';
import 'rxjs/add/operator/map';

import { AppComponent } from '../app.component';
import { environment } from '../environment';
import { Account, Machine, NewAccount } from '../models/account';
import { Claim } from '../models/claim';
import { Country } from '../models/country';
import { Product } from '../models/product';
import { Item } from '../models/item';
import { Character } from '../models/character';
import { Background } from '../models/background';

import { DiscordUser, DiscordRoles, DiscordMessage } from '../models/discord'

@Injectable()
export class UserService { 
	private headers = new Headers({'Content-Type': 'application/json'});
	public token: any;
	public future: any;
	
	account: Account;

	constructor(private http 		 : Http,
				private cookie 		 : CookieService,
				private track 		 : Angulartics2) {
		
		// set token if saved in local storage
		this.token = this.cookie.get('id');
		
		// Generate times
		this.future = new Date();
		this.future.setMinutes(this.future.getMinutes() + 300000);

		this.account = null;

	}

	emitAccountChange( acc ) {
		this.account = acc;
	}

	getAccount() {
		return this.account;
	}


	getToken() {
		return this.token;
	}
	

	claimGameKey() {
		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Ask the backend to authenticate the user
	   	return this.http.get(`${environment.baseUrl}/claimgamekey/`, options)
	}

	/**
	* 		Service to log a user in
	**/
	login(username: string, password: string): Observable<any> {
		
		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('username', btoa(username));
		data.append('password', btoa(password));

		// Ask the backend to authenticate the user
	   	return this.http.post(`${environment.baseUrl}/authenticate/`, data)
			.map((response: Response) => {

				let resp = response.json();

				if ( resp.code == 200 ) {

					let user = response.json().account.map(toAccount);
					this.emitAccountChange(user);

					// Find the token in the JSON web data
					let token = response.json().jwt;
					this.token = token;

					// Store it in the cookie
					this.cookie.put('id', token, { expires: this.future });

				}

				// Return true to indicate successful login
				return response.json();

			
			});
	}
	
	/**
	* 		Service to log a user in
	**/
	authorizeUser(): Observable<Account> {

		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Ask the backend to authenticate the user
	   	return this.http.get(`${environment.baseUrl}/authorize/`, options)
		.map((response: Response) => {
			if (response.text()) {
				let user = mapAccount(response);
				this.emitAccountChange(user);
				return user;
			} else {
				// this.cookie.remove('id');
				return null;
			}
		});

	}


	/**
	* 		Log a user out
	**/
	logout(): Observable<any> {

		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Reset the user token and remove the cookie
		this.token = null;
		this.emitAccountChange(null);
		this.account = null;
		this.cookie.remove('id');

		// Send the Authorization request server-side
		return this.http.get(`${environment.baseUrl}/logout/`,options);
	}





	/**
	* 		Check Dual Factor Key
	**/

	dualFactor(key): Observable<boolean> {
		let data = new URLSearchParams();
		data.append('code', btoa(key));
	   	return this.http.post(`${environment.baseUrl}/auth/`, data)
			.map((response: Response) => {
				if ( response.text() ) {
					return true;
				} else {
					return false;
				}
			});
	}


	/**
	* 		Setup a new Dual Factor account
	**/

	setupDualFactor(): Observable<any> {
		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

	   	return this.http.get(`${environment.baseUrl}/auth/setup/`, options)
			.map((response: Response) => {
				if ( response.json() )
					return response.json();
			});
	}





	/**
	* 		Search for Users, Products, Items
	**/
	search(query): Observable<any> {

		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('q', query);

		// Ask the backend to authenticate the user
	   	return this.http.post(`${environment.baseUrl}/s/`, data)
			.map((response: Response) => {

				let items = response.json().items.map(toItems);
				let product = response.json().products.map(toProduct);
				let users = response.json().accounts.map(toAccount);

				return [items, product, users];
			});

	}





	/**
	* 	Account Ping
	**/
	pingServer():  Observable<any> {

		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Send the Authorization request server-side
		return this.http.get(`${environment.baseUrl}/ping/`, options);

	}


	/**
	*		Generating a new URL for Logging in with OAuth
	**/
	generateOAuthURL(service, add?): Promise<any> {
		// Append add if adding this service to an account
		let url = (add === true) ? 'add/' : '';
		// Send the Authorization request server-side
		return this.http
			.get(`${environment.baseUrl}/${service}/`+url)
			.toPromise()
			.then((response) => {
				return response.json().url;
			})
			.catch((err) => { 
				// toss, no user
			});
	}


	/**
	*		Check OAuth Return URL for creds after a user has signed in
	**/
	checkOAuth(service, data?): Observable<any> {

		// Let details be mapped to the post
		let details = new URLSearchParams();
		if (data)
			details.append('accesskey', data);

		// Send the Authorization request server-side
		return this.http
			.post(`${environment.baseUrl}/${service}/check/`, details)
			.map((response: Response) => {
				// A JWT Web Token is generated server-side
				if (response.text().toLowerCase() !== 'false') {
					let user = response.json().account.map(toAccount);
					this.emitAccountChange(user);

					// Find the token in the JSON web data
					let token = response.json().jwt;
					this.token = token;

					// Store it in the cookie
					this.cookie.put('id', token, { expires: this.future });

					// Return true to indicate successful login
					return true;

				} else {

					// Return false to indicate failed login
					return false;

				}
			});
	}


	/**
	*		Check OAuth Return URL for creds after a user has signed in
	**/
	addOAuth(service, data?): Observable<any> {

		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Let details be mapped to the post
		let details = new URLSearchParams();
		if (data)
			details.append('accesskey', data);

		// Send the Authorization request server-side
		return this.http
			.post(`${environment.baseUrl}/${service}/add/check/`, details, options)
			.map((response: Response) => {
				// A JWT Web Token is generated server-side
				if ( response.text()) {

					let user = response.json().account.map(toAccount);

					// Return true to indicate successful login
					return user;

				} else {
					// Return false to indicate failed attempt
					return false;
				}
			});
	}


	/**
	*		Remove an OAuth Service from you account
	**/
	removeOAuth(service): Promise<Account> {

		// Generate a header which is decoded to determine the user 
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });
		
		// Send the Authorization request server-side
		return this.http
			.get(`${environment.baseUrl}/${service}/remove/`,options)
			.toPromise()
			.then(mapAccount)
			.catch((err) => { 
				// toss, no user
			});

	}

	/**
	* 		Creating a new user
	**/
	createAccount(user: any): Promise<any> {

		// Create a post object for the user object data
		let data = new URLSearchParams();
		data.append('user', btoa(JSON.stringify({ user: user })));

		// Fire up the backend 
		return this.http.post(`${environment.baseUrl}/createuser/`, data)
			.toPromise()
			.then((response) => {
				let resp = response.json();
				// let user = response.json().account.map(toAccount);
				// this.accounts.emit(user);

				// Find the token in the JSON web data
				let token = response.json().jwt;
				this.token = token;

				// Store it in the cookie
				this.cookie.put('id', token, { expires: this.future });	
				
				this.track.eventTrack.next({ action: 'CompleteRegistration' });

				return resp;
			})
			.catch((err) => { 
				throw(err);
				// toss, no user
			});
	}

	/**
	* 	Activate a user
	**/
	activate(key: string): Promise<any> {

		let data = new URLSearchParams();
		data.append('key', key);

		return this.http.post(`${environment.baseUrl}/activate/`, data)
			.toPromise()
			.then((response) => {
				let resp = response.json();
				return resp;
			});
	}

	/**
	* 	Update Tagline
	**/
	updateTagline(tagline: string): Promise<any> {

		// Generate a header which is decoded to determine the user 
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		let data = new URLSearchParams();
		data.append('tagline', tagline);

		return this.http.post(`${environment.baseUrl}/updateusertagline/`, data, options)
			.toPromise()
			.then((response) => {
				return response.json();
			});
	}


	/**
	* 		Changing a user's profile image
	**/

	changeProfilePic( file: any ): Observable<string> {
		let identity = this.cookie.get('id');

		// Authorize a user with JWT headers before purchasing...
		let headers = new Headers({
			'Authorization': 'Bearer ' + identity
		});

		return this.http.post(`${environment.baseUrl}/profileimage/`, file, { headers: headers })
			.map((response: Response) => {
				if ( response.text() ) {

					let user = response.json().account.map(toAccount);
					this.emitAccountChange(user);

					return response.text()

				} else {
					return false;
				}
		});
	}


	getDiscordUsers(): Promise<DiscordUser> {
		// Add authorization header with jwt token
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });
		return this.http
			.get(`${environment.baseUrl}/discord/users/`, options)
			.toPromise()
			.then(mapDiscordUsers)
			.catch(handleError)
	}

	getDiscordRoles(): Promise<DiscordRoles> {
		// Add authorization header with jwt token
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });
		return this.http
			.get(`${environment.baseUrl}/discord/roles/`, options)
			.toPromise()
			.then(mapDiscordRoles)
			.catch(handleError)
	}

	getDiscordMessages(): Promise<DiscordMessage> {
		// Add authorization header with jwt token
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });
		return this.http
			.get(`${environment.baseUrl}/discord/messages/`, options)
			.toPromise()
			.then(mapDiscordMessage)
			.catch(handleError)
	}

	sendDiscordMessage( text ): Promise<DiscordMessage> {
		// Add authorization header with jwt token
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('text', text);

		return this.http
			.post(`${environment.baseUrl}/discord/send/`, data, options)
			.toPromise()
			.then(mapDiscordMessage)
			.catch(handleError)
	}


	/**
	* 		Checking if an Identity already exists
	**/

	checkUser(user: any): Observable<boolean> {
		return this.http.get(`${environment.baseUrl}/checkuser/?username=${user}`, 
			{ headers: this.getHeaders() })
			.map((response: Response) => {
				return (response.text()) ? false : true;
			});
	}


	/**
	* 		Check if an email already exists
	**/

	checkEmail(email: any): Observable<boolean> {
	   return this.http.get(`${environment.baseUrl}/checkemail/?email=${email}`, 
		{ headers: this.getHeaders() })
		.map((response: Response) => {
			return (response.text()) ? false : true;
		});
	}


	/**
	* Recover Account
	**/
	recoverPassword(username: string, email: string): Observable<any> {
		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('username', username);
		data.append('email', email);

	   return this.http.post(`${environment.baseUrl}/reset_password/`, data,
		{ headers: this.getHeaders() })
		.map((response: Response) => {
			return response.json()
		});
	}

	recoverUsername(email: string): Observable<any> {
		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('email', email);

	   return this.http.post(`${environment.baseUrl}/send_username/`, data,
		{ headers: this.getHeaders() })
		.map((response: Response) => {
			return response.json()
		});
	}

	verifyEmail(email: string): Observable<any> {
		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('email', email);

	   return this.http.post(`${environment.baseUrl}/resend_verification/`, data,
		{ headers: this.getHeaders() })
		.map((response: Response) => {
			return response.json()
		});
	}

	recoverAccount(key: string, pass: string): Observable<any> {
		
		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('key', key);
		data.append('password', pass);

		return this.http.post(`${environment.baseUrl}/recover_account/`, data,
		{ headers: this.getHeaders() })
		.map((response: Response) => {
			return response.json()
		});
	}


	/**
	* 		Get a user's account balance
	**/
	accountBalance(): Promise<Account> {
		// Add authorization header with jwt token
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });
		return this.http
			.get(`${environment.baseUrl}/accountbalance/`,options)
			.toPromise()
			.then(mapAccount)
			.catch(handleError)
	}

	/**
	* 		Get a user's claims in a secure manor
	**/
	getClaims(): Promise<Claim> {
		// Add authorization header with jwt token
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });
		return this.http
			.get(`${environment.baseUrl}/userclaims/`, options)
			.toPromise()
			.then(mapClaim)
	}


	/**
	* 		Get a user's claims in a secure manor


		// Add authorization header with jwt token
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });
		return this.http
			.post(`${environment.baseUrl}/userclaims/`, options)
			.map((response: Response) => {
				return response.json().count;
			});

	**/

	getClaimsCount(): Promise<any> {

		// Authorize a user with JWT headers before purchasing...
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		return this.http
			.get(`${environment.baseUrl}/userclaims/`, options)
			.toPromise()
			.then((responce) => {
				return responce.json().count;
			})
			.catch((err) => { console.log(err); } )
	}



	/**
	* 		Get a public profile for an account holder
	**/
	inviteToSocialNetwork(email: string): Promise<Account> {
	
		// Authorize a user with JWT headers before purchasing...
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		let data = new URLSearchParams();
		data.append('email', email);

		return this.http
			.post(`${environment.baseUrl}/social/invite/?email=${email}`, data, options)
			.toPromise()
			.then(mapAccount)
			.catch((err) => { console.log(err); } )

	}




	/**
	* 		Get a public profile for an account holder
	**/
	getProfile(username: string): Promise<Account> {
		// Create a post object for the user login

		return this.http
			.get(`${environment.baseUrl}/profile/?username=${username}`)
			.toPromise()
			.then(mapAccount)
			.catch( ( err ) => {
				// toss
			});
	}


	/**
	* 		Get a public profile for an account holder
	**/
	getCountryCodes(): Promise<Country> {
		// Create a post object for the user login

		return this.http
			.get(`${environment.baseUrl}/countries/`)
			.toPromise()
			.then(mapCountry)
			.catch( ( err ) => {
				// toss
			});
	}



	/**
	* 		Get a public profile for an account holder
	**/
	userMachines(): Promise<Machine> {

		// Link the forum account with a username and password
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Create a post object for the user login
		return this.http
			.get(`${environment.baseUrl}/machines/`, options)
			.toPromise()
			.then(mapMachine)
			.catch( ( err ) => {
				// toss
			});
	}


	/**
	* 		Logout from a remote machine
	**/
	countUserMachines(): Observable<any> {
		
		// Link the forum account with a username and password
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		return this.http
			.post(`${environment.baseUrl}/machines/`, options)
			.map((response: Response) => {
				return response.json().count;
			});
	}


	/**
	* 		Logout from a remote machine
	**/
	remoteLogout( machineIdentifier ): Observable<any> {
		
		// Link the forum account with a username and password
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });
		
		// Send encoded details to the server
		let data = new URLSearchParams();
			data.append( 'id', machineIdentifier );

		return this.http
			.post(`${environment.baseUrl}/machines/remove/`, data, options)
			.map((response: Response) => {
				let resp = response.json();
				return resp;
			});
	}






	/**
	* 		Link a Forum account
	**/
	linkForum(username: string, password: string): Observable<any> {
		
		// Link the forum account with a username and password
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });
		
		// Send encoded details to the server
		let details = '{ "username": "'+username+'", "password": "'+password+'" }';
		let data = new URLSearchParams();
			data.append( 'forum', btoa( details ) );

		return this.http
			.post(`${environment.baseUrl}/linkforum/`, data, options)
			.map((response: Response) => {
				let resp = response.json()
				if ( resp.code == 200 ) {
					let user = resp.status;
					return user;
				} else {
					return resp;
				}
			});
	}




	/**
	* 		Link a Forum account
	**/
	unlinkForum(): Observable<any> {
		// Link the forum account with a username and password
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		return this.http.get(`${environment.baseUrl}/unlinkforum/`, options).map((response: Response) => {
			let resp = response.json()
			return resp;
		});
	}


	/**
	* Determine if user is admin
	**/
	isAdmin(): Observable<boolean>  {
		
		// Link the forum account with a username and password
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Send the Authorization request server-side
		return this.http
			.get(`${environment.baseUrl}/authorize/`,options)
			.map((responce: Response) => {
				let resp = responce.json()
				if ( resp.user[0].role == "admin" )
					return true;
			})

	}


	/**
	* Get Preset Backgrounds
	**/
	getBackgrounds(name?: string): Promise<Background> {
		return this.http
			.get(`${environment.baseUrl}/backgrounds/?name=`+name)
			.toPromise()
			.then(mapBackgrounds)
			.catch( ( err ) => {
				// Throw, no error
			})
	}

	/**
	* Save Backgrounds
	**/
	saveBackground(url?: string): Promise<Background> {
		return this.http
			.get(`${environment.baseUrl}/savebackground/`)
			.toPromise()
			.then(mapBackgrounds)
			.catch( ( err ) => {
				// Throw, no error
			})
	}

	/**
	* Save user profile data
	**/
	updateAccount( profile: any ): Promise<Account> {
		// Add authorization header with jwt token
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		let data = new URLSearchParams();
		data.append( 'username', profile.username );
		data.append( 'firstname', profile.firstname );
		data.append( 'surname', profile.surname );
		data.append( 'email', profile.email );
		data.append( 'background', profile.background );
		data.append( 'tagline', profile.tagline );
		data.append( 'profile', profile.profile );
		data.append( 'password', btoa(profile.password) );
		data.append( 'sex', profile.sex );
		data.append( 'street', profile.street );
		data.append( 'housenumber', profile.housenumber );
		data.append( 'zip', profile.zip );
		data.append( 'city', profile.city );
		data.append( 'state', profile.state );
		data.append( 'countrycode', profile.countrycode );
		data.append( 'newsletter', profile.newsletter );
		if ( profile.birthdate )
			data.append( 'birthdate', profile.birthdate.formatted );

		return this.http
			.post(`${environment.baseUrl}/updateuser/`, data, options)
			.toPromise()
			.then(mapAccount)
	}





	selectedCharacter(): Promise<Character> {
		
		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		return this.http.get(`${environment.baseUrl}/character/`, options)
			.toPromise()
			.then(mapCharacters)
			.catch((err) => { 
				// toss, no user
			});	

	}



	loadUsersCharacters(): Promise<Character> {
		
		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		return this.http.get(`${environment.baseUrl}/characters/`, options)
			.toPromise()
			.then(mapCharacters)
			.catch((err) => { 
				// toss, no user
			});	

	}


	// Open a new pop-up
	openWindow(windowHeight, windowWidth, windowName, windowUri) {

		var centerWidth = (window.screen.width - windowWidth) / 2;
		var centerHeight = (window.screen.height - windowHeight) / 2;

		let newWindow = window.open(windowUri, windowName, 'resizable=0,width=' + windowWidth + 
			',height=' + windowHeight + 
			',left=' + centerWidth + 
			',top=' + centerHeight);

		if ( newWindow ) {
			newWindow.focus();
			return newWindow.name;
		} else {
			 return;
		}

		
	}





	private getHeaders() {
		let headers = new Headers();
		headers.append('Accept', 'application/json');
		return headers;
	}



}

/**
* 		Mapping data returned from the server helps us pass it along angular's components and pipes.
*		Responses are made readable with .json(), selected, and sent to a .map() function.
* 		Maps generally match up to files found in './models' ( using data types string,number,boolean,any )
*
*		<Account> model is filled with (r:any) any type of responce data.
**/


/**
* 		Managing product data
**/

function mapAccount(response:Response): Account {
	let res = response.json().user.map(toAccount);
	return res;
}

function mapAccounts(response:Response): Account {
	let res = response.json().users.map(toAccount);
	return res;
}

function toAccount(r:any): Account{
	// Check whether values exists in the array.
	let arrayIncludes = (arr:any[], targetVal) => {
		for (let i = 0; i < arr.length; i++)
			if(arr[i] === targetVal)
				return true

		return false;
	}


	let user = <Account>({
		id: r.id,
		username: r.username,
		forum_username: r.forum_username,
		forum_id: r.forum_id,
		tagline: r.tagline,
		background: r.background,
		firstname: r.firstname,
		surname: r.surname,
		profile: r.profile,
		profile_raw: r.profile_raw,
		email: r.email,
		password: r.password,
		birthdate: r.birthdate,
		image: r.image,
		sex: r.sex,
		street: r.street,
		housenumber: r.housenumber,
		zip: r.zip,
		city: r.city,
		state: r.state,
		social: r.social,
		chat: r.chat,
		countrycode: r.countrycode,
		subscriptionproduct: r.subscriptionproduct,
		subscriptionenddate: r.subscriptionenddate,
		renewalinprogress: r.renewalinprogress,
		accountstate: r.accountstate,
		screenshots: r.screenshots,
		num_slots: r.num_slots,
		referrer: r.referrer,
		site_referrer: r.site_referrer,
		verification_key: r.verification_key,
		createdip: r.createdip,
		modified: r.modified,
		created: r.created,
		lastlogin: r.lastlogin,
		lastpassword: r.lastpassword,
		lastmailed: r.lastmailed,
		token_mailed: r.token_mailed,
		currency: r.currency,
		balance: r.balance,
		newsletter: r.newsletter,
		login_token: r.login_token,
		live_id: r.live_id,
		has_live: r.has_live,
		facebook_id: r.facebook_id,
		has_facebook: r.has_facebook,
		steam_id: r.steam_id,
		has_steam: r.has_steam,
		claimedItems: r.claimed_items,
		has_beta_access: arrayIncludes(r.claimed_items, '23'), // 23 is the product ID for "Beta" access.
		gameKey: r.game_key,
		items: r.items,
		claims: r.claims,
		code: r.code,
		error: r.error
	});
	return user;
}

function mapNewAccount(response:Response): NewAccount {
	return response.json().map(toNewAccount);
}

function toNewAccount(r:any): NewAccount {
	let newAccount = <NewAccount>({
		code: r.code,
		result: r.result,
		verifyemail: r.verifyemail,
		account: r.account,
		jwt: r.jwt
	});
	return newAccount;
}


/**
* Discord
**/

function mapDiscordUsers(response:Response): DiscordUser {
	return response.json().members.map(toDiscordUsers);
}

function toDiscordUsers(r:any): DiscordUser {
	let user = <DiscordUser>({
		user_id: r.user_id,
		username: r.username,
		presence: r.presence,
		avatar: r.avatar,
		bot: r.bot,
		role: r.role
	});
	return user;
}


function mapDiscordRoles(response:Response): DiscordRoles {
	return response.json().roles.map(toDiscordRoles);
}

function toDiscordRoles(r:any): DiscordRoles {
	let role = <DiscordRoles>({
		id: r.id,
		name: r.name,
		members: r.members,
		icon: r.icon,
		memberCount: r.memberCount,
		position: r.position,
		hoist: r.hoist,
		color: r.color
	});
	return role;
}


function mapDiscordMessage(response:Response): DiscordMessage {
	console.log(response);
	return response.json().messages.map(topDiscordMessage);
}

function topDiscordMessage(r:any): DiscordMessage {
	let message = <DiscordMessage>({
		id: r.id,
		channel: r.channel,
		author: r.author,
		user_id: r.author_id,
		avatar: r.avatar,
		type: r.type,
		mentions: r.mentions,
		content: r.content,
		reactions: r.reactions,
		attachments: r.attachments
	});
	return message;
}



/**
* Logged-In Machines
**/


function mapMachine(response:Response): Machine {
	return response.json().machines.map(toMachine);
}

function toMachine(r:any): Machine {
	let machines = <Machine>({
		ip_address: r.ip_address,
		accountid: r.accountid,
		browser: r.browser,
		machine: r.machine,
		system: r.system,
		active: r.active,
		agent: r.agent,
		icon: r.icon,
		time: r.time,
		jti: r.jti,
		key: r.key,
		id: r.id
	});
	return machines;
}



/**
* 		Managing product data
**/

function mapProduct(response:Response): Product {
	let res = response.json().item.map(toProduct);
	return res;
}

function mapProducts(response:Response): Product {
	let res = response.json().items.map(toProduct);
	return res;
}

function toProduct(r:any): Product {
	let product = <Product>({
		id: r.id,
		beta: r.beta,
		currency: r.currency,
		category: r.category,
		description: r.description,
		html: r.html,
		rich_html: r.rich_html,
		discount: r.discount,
		images: r.images,
		imagecount: r.imagecount,
		imagesizes: r.imagesizes,
		instock: r.instock,
		stock: r.stock,
		items: r.items,
		itemsCount: r.itemsCount,
		icon: r.icon,
		limit: r.limit,
		oldprice: r.oldprice,
		owns: r.owns,
		originalprice: r.originalprice,
		price: r.price,
		points: r.points,
		limited: r.limited,
		pointValues: r.pointValues,
		countPoints: r.countPoints,
		product: r.product,
		type: r.type,
		removeitems: r.removeitems,
		title: r.title,
		published: r.published,
		quantity: r.quantity
	});
	return product;
}

function mapItem(response: Response): Item {
	return response.json().items.map(toItems);
}

function toItems(r:any): Item {
	let storeItem = <Item>({
		id: r.id,
		title: r.title,
		label: r.label,
		description: r.description,
		html: r.html,
		plural: r.plural,
		value: r.value,
		slug: r.slug,
		icon: r.icon,
		points: r.points,
		pointValues: r.pointValues,
		countPoints: r.countPoints,
		images: r.images,
		imagecount: r.imagecount,
		imagesizes: r.imagesizes,
		owns: r.owns,
		price: r.price,
		discount: r.discount,
		stock: r.stock,
		instock: r.instock,
		category: r.category,
		category_info: r.category_info,
		group: r.group,
		models: r.models,
		build_state: r.build_state,
		group_info: r.group_info,
		rich_html: r.rich_html,
		published: r.published,
		hidden: r.hidden,
		packaged_items: r.packaged_items,
		limit: r.limit,
		updated_by: r.updated_by,
		created: r.created,
		modified: r.modified,
		type: r.type,
		customize: r.customize,
		quantity: r.quantity
	});
	return storeItem;
}



/**
* 		Map claim data
**/

function mapClaim(response:Response): Claim {
	let res = response.json().claims.map(toClaim);
	return res;
}

function toClaim(r:any): Claim {
	let claim = <Claim>({
		added: r.added,
		accountid: r.accountid,
		claimedon: r.claimedon,
		reward: r.reward,
	});
	return claim;
}


/**
* 		Map country
**/

function mapCountry(response:Response): Country {
	let res = response.json().countries.map(toCountry);
	return res;
}

function toCountry(r:any): Country {
	let country = <Country>({
		id: r.id,
		name: r.name
	});
	return country;
}




/**
* 		Map country
**/

function mapCharacters(response:Response): Character {
	let res = response.json().characters.map(toCharacters);
	return res;
}

function toCharacters(r:any): Character {
	let character = <Character>({
		id: r.id,
		accountid: r.accountid,
		name: r.name,
		characterCustomization: r.characterCustomization,
		bankMoney: r.bankMoney,
		equipped: r.equipped,
		created: r.created,
		modified: r.modified,
		lastseen: r.lastseen,
		currentlyactive: r.currentlyactive
	});
	return character;
}

/**
* 		Map claim data
**/

function mapBackgrounds(response:Response): Background {
	let res = response.json().backgrounds.map(toBackground);
	return res;
}

function toBackground(r:any): Background {
	let bg = <Background>({
		id: r.id,
		title: r.title,
		url: r.url
	});
	return bg;
}


/**
* 		Error Handling
**/

// this could also be a private method of the component class
function handleError (error: any) {
	// log error
	// could be something more sofisticated
	let errorMsg = error.message || `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`;
	console.error(errorMsg);

	// throw an application level error
	return Observable.throw(errorMsg);
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/services/user.service.ts